import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {Page} from "../flipp-page/Page";
import {i18n} from "../../i18n/I18n";
import {fetchJSON} from "../../utils/fetch";
import {orderBy, uniqBy, upperFirst} from "lodash-es";
import {inject} from "../../services/di";
import {ConfigService} from "../../services/ConfigService";
import {LocationService} from "../../services/LocationService";

export interface LinkData {
	name: string;
	link: string;
}

type StoreCityFlyersModel = {
	cities: LinkData[],
};

@element("store-city-flyers")
export class StoreCityFlyers extends Component<any, any> {
	@inject config: ConfigService;
	@inject location: LocationService;

	async prepare() {
		const json = await fetchJSON(`${this.config.FLIPP_COM_APIS}/city?country=ca`);
		const cities = [] as LinkData[];
		const getInCityName = (state: string, city: string) => {
			const cityName = city
				.split(" ")
				.map((c: string) => c.toLowerCase())
				.join("-")
				.replace("'", "");
			return `${cityName}-${state.toLowerCase()}`;
		};
		orderBy(uniqBy(json as {cityName: string, state: string}[], "cityName"), (city) => city.cityName.toLowerCase(), ["asc"]).forEach((cityState) => {
			const link = `/${getInCityName(cityState.state, cityState.cityName)}/stores`;
			const name = cityState.cityName.split(" ").map(item => (upperFirst(item))).join(" ");
			const item = { name, link };
			cities.push(item);
		});
		return {cities} as StoreCityFlyersModel;
	}

	render({cities}: StoreCityFlyersModel) {
		return <Page show="flyers">
			<div class="marketing link-hub">
				<div class="content-wrapper">
					<h1>{i18n("storeCityFlyers_title")}</h1>
					<ul class="all-cities">
						{cities.map((city) => (
							renderSingleRow({
								link: city.link,
								text: i18n("store_locationStore", { city: city.name }),
								locale: this.location.locale
							})
						))}
					</ul>
				</div>
				{renderFooter(this.location.locale)}
			</div>
		</Page>;
	}

}


export function renderSingleRow({ link, text, locale }: { link: string; text: string, locale: string }) {
	return (<li class="single-link">
		<a href={`/${locale}${link}`}>{text}</a>
	</li>);
}


export function renderFooter(locale: string) {
	return (
		<div class="footer">
			<div class="content-wrapper">
				<div class="subwrapper">
					<div class="leftFloat">
						<ul>
							<li class="uppercase">{i18n("footer_company")}</li>
							<li>
								<a href="https://blog.flipp.com/">{i18n("footer_blog")}</a>
							</li>
							<li>
								<a href="https://corp.flipp.com/partners/">
									<a>{i18n("footer_retailers")}</a>
								</a>
							</li>
							<li>
								<a href="https://corp.flipp.com/job-openings/">
									<a>{i18n("footer_careers")}</a>
								</a>
							</li>
							<li>
								<a href={`/${locale}/stores`}>{i18n("footerStores")}</a>
							</li>
							<li>
								<a href={"https://help.flipp.com/"}>{i18n("helpCenter")}</a>
							</li>
						</ul>
						<ul>
							<li class="uppercase">{i18n("footerStoresFlyers")}</li>
							{storesRow1.map((store) => (
								renderSingleRow({
									link: store.link,
									text: i18n("store_title", { storeName: store.name }),
									locale
								})
							))}
						</ul>
						<ul class="row-without-title">
							{storesRow2.map((store) => (
								renderSingleRow({
									link: store.link,
									text: i18n("store_title", { storeName: store.name }),
									locale
								})
							))}
						</ul>
						<ul class="row-without-title">
							{storesRow3.map((store) => (
								renderSingleRow({
									link: store.link,
									text: i18n("store_title", { storeName: store.name }),
									locale
								})
							))}
						</ul>
						<ul>
							<li class="uppercase">
								<a href="/store-city-flyers">{i18n("footerStoresFlyersByCity")}</a>
							</li>
							{storeFlyersByCity.map((store) => (
								renderSingleRow({
									link: store.link,
									text: i18n("store_locationStore", { city: store.name }),
									locale
								})
							))}
						</ul>
						<ul>
							<li class="uppercase">
								<a href="/flyers-canada">{i18n("footerCanadianCityFlyers")}</a>
							</li>
							{cityFlyers.map((flyer) => (
								renderSingleRow({
									link: flyer.link,
									text: i18n("flyer_location_title", { city: flyer.name }),
									locale
								})
							))}
						</ul>
					</div>
				</div>
				{/*<div class="copyright">{i18n("footer_copyright")}</div>*/}
			</div>
		</div>
	);
}

const storesRow1 = [
	{
		name: "Metro",
		link: "/stores/metro",
	},
	{
		name: "Super c",
		link: "/montreal-qc/stores/super-c",
	},
	{
		name: "Food Basics",
		link: "/stores/food-basics",
	},
	{
		name: "Real Canadian Superstore",
		link: "/stores/real-canadian-superstore",
	},
	{
		name: "No Frills",
		link: "/stores/no-frills",
	},
	{
		name: "FreshCo",
		link: "/stores/freshco",
	},
	{
		name: "Foodland",
		link: "/toronto-on/stores/foodland",
	},
	{
		name: "Safeway",
		link: "/vancouver-bc/stores/safeway",
	},
];

const storesRow2 = [
	{
		name: "Zehrs",
		link: "/toronto-on/stores/zehrs",
	},
	{
		name: "Costco",
		link: "/stores/costco-wholesale",
	},
	{
		name: "Loblaws",
		link: "/stores/loblaws",
	},
	{
		name: "Maxi",
		link: "/montreal-qc/stores/maxi",
	},
	{
		name: "Save on Foods",
		link: "/stores/save-on-foods",
	},
	{
		name: "IGA",
		link: "/montreal-qc/stores/iga",
	},
	{
		name: "Co-op",
		link: "/edmonton-ab/stores/co-op",
	},
	{
		name: "Save on Foods",
		link: "/surrey-bc/stores/save-on-foods",
	},
	{
		name: "Fortinos",
		link: "/mississauga-on/stores/fortinos",
	},
];

const storesRow3 = [
	{
		name: "Home Depot",
		link: "/stores/the-home-depot",
	},
	{
		name: "Independent Grocer",
		link: "/stores/your-independent-grocer",
	},
	{
		name: "T&T Supermarket",
		link: "/stores/tt-supermarket",
	},
	{
		name: "Farm Boy",
		link: "/stores/farm-boy",
	},
	{
		name: "Longo`s",
		link: "/stores/longos",
	},
	{
		name: "Best Buy",
		link: "/stores/best-buy",
	},
	{
		name: "Lowe`s",
		link: "/stores/lowes",
	},
];

const storeFlyersByCity = [
	{
		name: "Toronto",
		link: "/toronto-on/stores/",
	},
	{
		name: "Mississauga",
		link: "/mississauga-on/stores/",
	},
	{
		name: "Montreal",
		link: "/ontreal-qc/stores/",
	},
	{
		name: "Vancouver",
		link: "/vancouver-bc/stores/",
	},
	{
		name: "Calgary",
		link: "/calgary-ab/stores/",
	},
	{
		name: "Edmonton",
		link: "/edmonton-ab/stores/",
	},
	{
		name: "Ottawa",
		link: "/ottawa-on/stores/",
	},
	{
		name: "Winnipeg",
		link: "/winnipeg-mb/stores/",
	},
	{
		name: "Quebec",
		link: "/quebec-qc/stores/",
	},
	{
		name: "Hamilton",
		link: "/hamilton-on/stores/",
	},
	{
		name: "Kitchener",
		link: "/kitchener-on/stores/",
	},
	{
		name: "London",
		link: "/london-on/stores/",
	},
	{
		name: "Victoria",
		link: "/victoria-bc/stores/",
	},
	{
		name: "Halifax",
		link: "/halifax-ns/stores/",
	},
	{
		name: "Oshawa",
		link: "/oshawa-on/stores/",
	},
	{
		name: "Windsor",
		link: "/windsor-on/stores/",
	},
	{
		name: "Saskatoon",
		link: "/saskatoon-sk/stores/",
	},
];

const cityFlyers = [
	{
		name: "Calgary",
		link: "/calgary-ab/flyers/",
	},
	{
		name: "Vancouver",
		link: "/vancouver-bc/flyers/",
	},
	{
		name: "Toronto",
		link: "/toronto-on/flyers/",
	},
	{
		name: "Mississauga",
		link: "/mississauga-on/flyers/",
	},
	{
		name: "Montreal",
		link: "/montreal-qc/flyers/",
	},
	{
		name: "Edmonton",
		link: "/edmonton-ab/flyers/",
	},
	{
		name: "Ottawa",
		link: "/ottawa-on/flyers/",
	},
	{
		name: "Winnipeg",
		link: "/winnipeg-mb/flyers/",
	},
	{
		name: "Quebec",
		link: "/quebec-qc/flyers/",
	},
	{
		name: "Hamilton",
		link: "/hamilton-on/flyers/",
	},
	{
		name: "Kitchener",
		link: "/kitchener-on/flyers/",
	},
	{
		name: "London",
		link: "/london-on/flyers/",
	},
	{
		name: "Victoria",
		link: "/victoria-bc/flyers/",
	},
	{
		name: "Halifax",
		link: "/halifax-ns/flyers/",
	},
	{
		name: "Oshawa",
		link: "/oshawa-on/flyers/",
	},
	{
		name: "Windsor",
		link: "/windsor-on/flyers/",
	},
	{
		name: "Saskatoon",
		link: "/saskatoon-sk/flyers/",
	},
];
